export const formatDate = (date) => {
    const month = `${date.getMonth() + 1}`.padStart(2, "0")
    const year = date.getFullYear()
    return `${month}.${year}`
}